export default "__VITE_ASSET__Mv8_CAe___"